import { Component, OnInit, AfterViewInit } from '@angular/core';

@Component({
  selector: '[mft-fcsmedia]',
  templateUrl: "./fcsmedia.component.html"
})
export class FCSMediaComponent implements OnInit, AfterViewInit {
  constructor() {

  }
  ngOnInit() {

  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/home/fcsmedia.component.ts